import { consoleLogger } from '@shared/logging/consoleLogger';
import { EventNameType, ListenerCallback } from '@shared/config/types';
import { UtiqEvents } from '@shared/events/events';

export const addEventListener = (
  event: EventNameType,
  callback: ListenerCallback,
) => {
  const utiqEventLastCall = window.Utiq?.events?.[event]?.lastCall;
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (UtiqEvents?.[event] && typeof callback === 'function') {
    if (!window.Utiq?.listeners?.[event]?.includes(callback)) {
      window.Utiq ||= {};
      window.Utiq.listeners ||= {};
      window.Utiq.listeners[event] ||= [];
      window.Utiq.listeners[event].push(callback);
    }
    if (utiqEventLastCall && Object.keys(utiqEventLastCall).length !== 0) {
      consoleLogger.logDebug(`Executing callback with event: ${event}`);
      try {
        callback(utiqEventLastCall.data, utiqEventLastCall.environment);
      } catch (err) {
        consoleLogger.logError(
          `Error on callback: ${callback}  for event: ${event} -> ${err}. Stopping callback execution`,
        );
      }
    }
  } else {
    consoleLogger.logError(
      `Couldn't find any event named: ${event}, or callback: ${callback} is not a function`,
    );
  }
};

export const removeEventListener = (
  event: EventNameType,
  callback: ListenerCallback,
) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (UtiqEvents?.[event] && typeof callback === 'function') {
    if (window?.Utiq?.listeners?.[event]) {
      consoleLogger.logDebug(`Removing callback from event: ${event}`);
      window.Utiq.listeners[event] = window.Utiq.listeners[event].filter(
        (func: ListenerCallback) => func !== callback,
      );
    } else {
      consoleLogger.logDebug(
        `Couldn't find any callback for event named: ${event}`,
      );
    }
  } else {
    consoleLogger.logError(
      `Couldn't find any event named: ${event}, or callback: ${callback} is not a function`,
    );
  }
};
